import Box from "@mui/material/Box";

// components
import { CollapsedSidebar } from "../../ui/collapsed-sidebar";

import { TabsResults } from "./tabs-results";

export const SidebarResultsRight = ({
  selectedBuilding,
  selectedResult,
  propertyArea,
  isLeftSide = false,
  showGrid,
  setShowGrid,
  surveyData,
  getSelectedGridIndex,
  setSelectedGridIndex,
}) => {
  let totalBuildingsArea = 0;
  if (selectedResult && selectedResult.buildings.length > 0) {
    selectedResult.buildings.forEach(
      (b) => (totalBuildingsArea = totalBuildingsArea + b.kpis.area),
    );
  }

  return (
    <CollapsedSidebar
      title={"Analysis"}
      displayTutorialBtn={true}
      displayBackBtn={false}
      left={isLeftSide}
      surveyData={surveyData}
    >
      <Box
        sx={{
          /* padding: "16px", */
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          overflow: "auto",
        }}
        className="sidebar-results-right"
      >
        <TabsResults
          selectedBuilding={selectedBuilding}
          selectedResult={selectedResult}
          propertyArea={propertyArea}
          totalBuildingsArea={totalBuildingsArea}
          showGrid={showGrid}
          setShowGrid={setShowGrid}
          getSelectedGridIndex={getSelectedGridIndex}
          setSelectedGridIndex={setSelectedGridIndex}
          isSurvey={surveyData ?? null}
        />
      </Box>
    </CollapsedSidebar>
  );
};
